import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const emptyProps = buildProps({
  image: {
    type: String,
    default: ""
  },
  imageSize: Number,
  description: {
    type: String,
    default: ""
  }
});

export { emptyProps };
//# sourceMappingURL=empty.mjs.map
